<div class="row mt-4">
    <div class="col-12">
        <div class="form-inline">
            <span class="badge badge-warning">
                <span class="material-icons">
                    scoreboard
                </span>
            </span>
            <h4 class="mt-2">Puntos de control</h4>
        </div>
    </div>
</div>
<div class="row mb-2" *ngIf="job">
    <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
        <div class="card h-100">
            <div class="card-header d-flex justify-content-between">
                <h4 class="card-title">{{job.name}}</h4>
                <button class="btn btn-icon btn-sm btn-info" (click)="downloadFile(this.job.name)"
                    [ngbTooltip]="'Descargar instructivo de '+ job.name">
                    <span class="material-icons">
                        download
                    </span>
                </button>
            </div>
            <div class="card-content">
                <div class="card-body">
                    <div class="table-responsive">
                        <table class="table table-sm table-bordered">
                            <thead>
                                <tr>
                                    <th>
                                        Porcedimiento
                                    </th>
                                    <th>
                                        Instructivo
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let procedure of procedures">
                                    <td>
                                        {{procedure.name}}
                                    </td>
                                    <td class="btn-download-cell">
                                        <button class="btn btn-icon btn-sm btn-success"
                                            (click)="downloadFile(procedure.url)"
                                            [ngbTooltip]="'Descargar instructivo de ' + procedure.name">
                                            <span class="material-icons">
                                                download
                                            </span>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
        <div class="card h-100">
            <div class="card-header">
                <h4 class="card-title">Juntas</h4>
            </div>
            <div class="card-content">
                <div class="card-body">
                    <div class="table-responsive">
                        <table class="table table-sm table-bordered">
                            <thead>
                                <tr>
                                    <th>Junta</th>
                                    <th>Frecuencia</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let council of councils">
                                    <td>{{council.council}}</td>
                                    <td>{{council.frecuence}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
        <div class="card h-100">
            <div class="card-header">
                <h4 class="card-title">Reportes</h4>
            </div>
            <div class="card-content">
                <div class="card-body">
                    <div class="table-responsive">
                        <table class="table table-sm table-bordered">
                            <thead>
                                <tr>
                                    <th>Reporte</th>
                                    <th>Frecuencia</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let report of reports">
                                    <td>{{report.report}}</td>
                                    <td>{{report.frecuence}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-12">
        <div class="card">
            <div class="card-header d-flex justify-content-between">
                <h4 class="card-title">Mis puntos de control</h4>
                <span class="material-icons cursor-pointer">
                    expand_less
                </span>
            </div>
            <div class="card-content">
                <div class="card-body">
                    <div class="table-responsive">
                        <table class="table table-sm table-bordered">
                            <thead>
                                <tr>
                                    <th>
                                        <span>Prioridad</span>
                                    </th>
                                    <th>
                                        <span>Punto de control</span>
                                    </th>
                                    <th>
                                        <span>Troubleshooting</span>
                                    </th>
                                    <th>
                                        <span>Periodo</span>
                                    </th>
                                    <th>
                                        <span>Completar</span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let checkPoint of checkPoints; let indexCheckPoint =  index;">
                                    <td>
                                        <span class="badge rounded bg-danger">{{checkPoint.priority}}</span>
                                    </td>
                                    <td>
                                        <span>{{checkPoint.checkPoint}}</span>
                                    </td>
                                    <td class="btn-download-cell">
                                        <button class="btn btn-sm btn-icon btn-success"
                                            (click)="downloadFile(checkPoint.url)"
                                            [ngbTooltip]="'Descargar Troubleshooting de ' + checkPoint.checkPoint">
                                            <span class="material-icons">
                                                download
                                            </span>
                                        </button>
                                    </td>
                                    <td>
                                        <span *ngIf="checkPoint.period === 1">Diaria</span>
                                        <span *ngIf="checkPoint.period === 7">Semanal</span>
                                        <span *ngIf="checkPoint.period === 15">Quincenal</span>
                                        <span *ngIf="checkPoint.period === 30">Mensual</span>
                                    </td>
                                    <td>
                                        <button
                                            class="btn {{checkPointData[checkPoint.id] ? 'btn-success' : 'btn-info'}}"
                                            (click)="doCheckPoint(checkPoint)"
                                            [disabled]="checkPointData[checkPoint.id]">
                                            {{ checkPointData[checkPoint.id] ? 'Completado' : 'Completar'}}
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>